import type { ApiError } from '@empathyco/playboard-core-domain'
import type { FieldValue } from '../models'
import type { FieldValueAdapter } from './interfaces'
import { injectable } from 'inversify'

export interface PlatformFieldValueEntity {
  id: string
  name: string
  externalId: string
  children?: Array<PlatformFieldValueEntity>
}

export interface PlatformFieldValueError {
  status: number
  data?: any
}

@injectable()
export class PlatformFieldValueAdapter
  implements FieldValueAdapter<PlatformFieldValueEntity, PlatformFieldValueError>
{
  decode(payload: PlatformFieldValueEntity): FieldValue {
    const { id, name, externalId, children } = payload ?? {}
    return {
      id,
      name,
      externalId,
      children: children?.map(child => this.decode(child)) ?? [],
    }
  }

  decodeError(error: PlatformFieldValueError): ApiError {
    return {
      status: error.status,
    }
  }
}
